import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { NewHome } from "../NewHome";
export const PrivateRouteX = ({ component: Component, ...rest }) => (
    <Route exact {...rest} render={props => (
        localStorage.getItem('user')
            ? <Component {...props} />
            : <NewHome />
    )} />
)